import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {ActivatedRoute} from '@angular/router';
import {UserService} from '../../generated/api/user.service';
import {UserLoggedRolesServiceService} from '../../authenticationModule/services/user-logged-roles-service.service';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {CustomUserService} from '../../services/custom-user.service';
import {UserUtilsService} from '../../services/user-utils.service';
import {PageCrud} from '../../Enum/page-crud.enum';
import {RoleService} from '../../services/role.service';
import {CompanyService} from '../../generated/api/company.service';
import {DadConfigService} from '../../dad-reporting/services/dad-config.service';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {
  AcknowledgedDomainConfirmationComponent
} from '../acknowledged-domain-confirmation/acknowledged-domain-confirmation.component';
import {ManageInvoiceRecipientsService} from '../../services/manage-invoice-recipients.service';
import {Company} from '../../models/company';
import {User} from '../../models/user';
import {BaseClientComponent} from '../base-client.component';
import {ConfirmationService} from 'primeng/api';
import {
  UserAuditHistoryComponent
} from '../audit-trail/user-audit-history/user-audit-history.component';

@Component({
  selector: 'app-user-crud',
  templateUrl: './user-crud.component.html',
  styleUrls: ['./user-crud.component.scss']
})
export class UserCrudComponent extends BaseClientComponent implements OnInit {

  @ViewChild(UserAuditHistoryComponent) private auditHistory: UserAuditHistoryComponent;

  page: PageCrud;
  submitted = false;
  loading = false;
  // alerts
  error = false;
  existingEmail = false;
  existingUserLink: string = null;
  success = false;
  userNotFound = false;
  successEditEmail = false;
  passwordIsValid = false;
  accessDenied = false;
  // user info
  currentCompany: Company;
  currentUser: User;
  roles: { label, description }[];
  currentUserRoles = [];
  newUserData = {};
  updateInfoUser = {};
  dadReportingsCheckbox: { id, name }[];
  billingAccounts: { id: string, label: string, formControlName: string }[];
  roleCheckBoxes: {
    id: string,
    formControlName: string,
    label: string,
    name: string,
    helperBlockText: string,
    groupId: number
  }[];
  unlockDialogDisplay = false;
  isEditModeConfirmed = false;
  isUserToEditInSameCompanyAsLoggedInUser = true;
  registerForm: UntypedFormGroup;
  unlockForm: UntypedFormGroup;
  passwordUnlockForm = {};
  invalidPasswordOnEditMode = false;
  isReceiveConfirmationEmails = true;
  successTransferSuperRole = false;
  enabledTransferSuperRoleButton = false;
  notAuthorized = false;
  userHasDifferentDomainName = false;
  userDomainIfHeHasDifferentDomainName: string;
  expiredNdaError = false;
  passwordIsInvalid = false;
  uniqRolesArray = [];
  uniqRolesErrorsArray: string[] = [];
  uniqRolesError = false;
  isFinanceUserSelected: boolean;
  superLockedByDistributionList = false;
  mckayEntities: any[];
  private companyUniqId: string;
  displayHelpPopUp = false;
  successMessage = '';
  errorMessage = '';
  isLastUserForAtLeastOneRole = false;

  constructor(private authenticationService: AuthenticationService,
              private confirmationService: ConfirmationService,
              private route: ActivatedRoute,
              private userService: UserService,
              private httpClient: HttpClient,
              private companyService: CompanyService,
              private utilsService: UtilsService,
              private userLoggedRolesServiceService: UserLoggedRolesServiceService,
              private roleService: RoleService,
              private customUserService: CustomUserService,
              private userUtilsService: UserUtilsService,
              public dialogService: DialogService,
              private dadConfigService: DadConfigService,
              private manageInvoiceRecipientsService: ManageInvoiceRecipientsService) {
    super();
    this.initializeRoleCheckboxes();
    this.initializeRegisterForm();
  }

  private initializeRoleCheckboxes() {
    this.roleCheckBoxes = this.roleService.roles.map(role => {
      return {
        id: 'formGroupRole' + role.id,
        formControlName: 'role' + role.id,
        label: role.sfGuardGroupDescription,
        name: role.sfGuardGroupName,
        helperBlockText: role.description,
        groupId: role.sfGuardGroupId
      };
    });
  }

  private initializeRegisterForm() {
    this.registerForm = new UntypedFormGroup({
      name: new UntypedFormControl('', Validators.required),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      roleSuper: new UntypedFormControl(false),
      roleAdministrator: new UntypedFormControl(false),
      roleDeveloper: new UntypedFormControl(false),
      roleOperations: new UntypedFormControl(false),
      roleFinance: new UntypedFormControl(false),
      roleDadReporter: new UntypedFormControl(false),
      roleMacPermissioner: new UntypedFormControl(false),
      daytimePhoneCountryCode: new UntypedFormControl(''),
      daytimePhoneNationalNumber: new UntypedFormControl(''),
      mobilePhoneCountryCode: new UntypedFormControl(''),
      mobilePhoneNationalNumber: new UntypedFormControl(''),
      commercialOptIn: new UntypedFormControl(true),
      receiveConfirmationEmails: new UntypedFormControl(true),
      isNotificationOnly: new UntypedFormControl(false),
      apiKey: new UntypedFormControl('')
    });
  }

  ngOnInit() {
    this.loading = true;
    this.isFinanceUserSelected = false;
    this.utilsService.lockUi();
    this.route.paramMap.subscribe(params => {
      const currentCompanyUniqId = params.get('currentCompanyUniqId');
      this.companyUniqId = params.get('companyUniqId');
      const userUniqId = params.get('userUniqId');
      const action = params.get('action');
      if (currentCompanyUniqId !== this.getUserCurrent().company.uniqid) {
        this.redirectionToHomePage();
        return;
      }
      this.isUserToEditInSameCompanyAsLoggedInUser = (currentCompanyUniqId === this.companyUniqId);
      if (!this.isUserToEditInSameCompanyAsLoggedInUser) {
        this.getClients(this.companyUniqId, action);
      } else {
        this.currentCompany = this.getUserCurrent().company;
        this.initializeRoleCheckboxesForVendorClient();
        this.initializeBillingAccountForms(action);
      }
      if (userUniqId === 'user' && action === 'new') {
        this.disabledSuperRole();
        this.initializeDadReportingCheckbox();
        this.page = PageCrud.ADD;
        this.closeLoading();
      } else {
        const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
          this.getUserDataAndInitializeForm(action, userUniqId);
        });
        this.subscriptions.push(response$);
      }
    });
    this.closeLoading();
  }

  private closeLoading() {
    this.loading = false;
    this.utilsService.unlockUi();
  }

  private getUserDataAndInitializeForm(action: string, userUniqId: string): void {
    this.userService.getUserItem(userUniqId).subscribe({
        next: user => {
          if (!user[0]) {
            this.userNotFound = true;
            this.closeLoading();
          } else {
            this.currentUser = user[0];
            if (this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser, ['ROLE_MCKAY_SUPER', 'ROLE_CLIENT_SUPER'
              , 'ROLE_CLIENT_ADMIN', 'ROLE_MCKAY_FINANCE', 'ROLE_CLIENT_FINANCE'])) {
              this.getMckayEntities();
            }
            this.initializeDadReportingCheckbox();
            this.setUserAuthorization(action);
            this.alterIsNotificationOnly();
            if (this.canConvertToDistributionList()) {
              this.customUserService.isLastUserForAtLeastOneRole(this.currentUser.uniqid).subscribe((res: any) => {
                this.isLastUserForAtLeastOneRole = !!res['isLastUserForAtLeastOneRole'];
              });
            }
          }
        },
        error: error => this.handleError(error)
      }
    );
  }

  private setUserAuthorization(action: string): void {
    const isAuthorized = this.isCurrentUserCanEdit(action);
    if (isAuthorized) {
      this.notAuthorized = true;
      this.closeLoading();
      return;
    }
    this.handleAuthorizedUser();
    this.closeLoading();
  }

  private isCurrentUserCanEdit(action: string): boolean {
    return this.currentUser.uniqid !== this.getUserCurrent().uniqid
      && !(this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.getUserCurrent(),
        ['ROLE_MCKAY_SUPER', 'ROLE_CLIENT_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_CLIENT_ADMIN']) && this.canEditUser(this.currentUser))
      && action === 'edit';
  }

  private handleAuthorizedUser(): void {
    this.roleSuperForm.setValue(this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser, ['ROLE_MCKAY_SUPER', 'ROLE_CLIENT_SUPER']));
    if (this.roleSuperForm.value && this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.getUserCurrent(),
      ['ROLE_MCKAY_SUPER', 'ROLE_CLIENT_SUPER', 'ROLE_MCKAY_ADMIN'])) {
      this.roleSuperForm.disable();
    }
    this.apiKeyForm.setValue(this.currentUser.apiKey);
    this.loadDataToEditAndShowPages();
    this.currentUserRoles = this.getGroup();
    const action = this.route.snapshot.paramMap.get('action');
    if (action === 'show') {
      this.page = PageCrud.SHOW;
      this.registerForm.disable();
    } else if (action === 'edit') {
      this.handleEditAction();
    }
    this.roles = this.roleService.roles.map(role => ({label: role.sfGuardGroupName, description: role.description}));
  }

  private handleEditAction(): void {
    this.page = PageCrud.EDIT;
    this.addPasswordFormToEditPage();
    if (this.isEditMode) {
      this.registerForm.enable();
      this.getForm('isNotificationOnly').disable();
      this.getForm('email').disable();
      this.disabledSuperRole();
    } else {
      this.registerForm.disable();
    }
    this.unlockForm = new UntypedFormGroup({
      password: new UntypedFormControl('', Validators.required)
    });
  }

  private handleError(error: any): void {
    if (error.status === 401) {
      this.accessDenied = true;
    } else {
      this.redirectionToHomePage();
    }
    this.closeLoading();
  }

  private initializeRoleCheckboxesForVendorClient() {
    if (this.currentCompany.label === 4) {
      this.roleCheckBoxes.splice(4, 3);
    }
  }

  private disabledSuperRole() {
    if (!this.isUserToEditInSameCompanyAsLoggedInUser
      || this.roleSuperForm.value === true
      || !this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.getUserCurrent(), ['ROLE_MCKAY_SUPER'])
      || this.isClientCompany(this.getUserCurrent().company)) {
      this.roleSuperForm.disable();
    }
  }

  private addPasswordFormToEditPage() {
    this.registerForm.addControl('password', new UntypedFormControl(''));
    this.registerForm.addControl('confirmPassword', new UntypedFormControl(''));
  }

  private initializeDadReportingCheckbox() {
    this.dadConfigService.getActiveDadConfigsForUserCrud()
      .subscribe(
        res => {
          this.dadReportingsCheckbox = res;
          this.dadReportingsCheckbox.forEach(dadConfig => {
            if (this.getForm(dadConfig.name)) {
              this.getForm(dadConfig.name).setValue(this.checkDad(dadConfig.id));
            } else {
              // tslint:disable-next-line:max-line-length
              this.registerForm.addControl(dadConfig.name, new UntypedFormControl({
                value: this.checkDad(dadConfig.id),
                disabled: (this.isEditPage() && !this.isEditMode) || this.isShowPage()
              }));
            }
          });
        }
      );
  }

  get isEditMode(): boolean {
    return this.isUserToEditInSameCompanyAsLoggedInUser || this.isEditModeConfirmed;
  }

  private getClients(companyUniqId: string, action: string) {
    this.companyService.getCompanyItem(companyUniqId).subscribe({
      next: company => {
        this.currentCompany = company[0];
        this.initializeRoleCheckboxesForVendorClient();
        this.initializeBillingAccountForms(action);
        if (this.page === PageCrud.ADD) {
          this.closeLoading();
        }
      }, error: () => {
        this.error = true;
        this.errorMessage = 'An error occurred while processing your request';
        this.closeLoading();
      }
    });
  }

  private initializeBillingAccountForms(action: string) {
    this.billingAccounts = [];
    for (const billingAccount of this.currentCompany.billingAccounts) {
      this.billingAccounts.push({
        id: billingAccount.id, label: billingAccount.name,
        formControlName: billingAccount.id + 'FormControl'
      });
      if (action === 'edit') {
        this.registerForm.addControl(billingAccount.id + 'FormControl', new UntypedFormControl({
          value: false,
          disabled: !this.hasMultipleBusinessUnits
        }));
      } else {
        // tslint:disable-next-line:max-line-length
        this.registerForm.addControl(billingAccount.id + 'FormControl', new UntypedFormControl({
          value: true,
          disabled: true
        }));
      }
    }
    if (this.currentUser) {
      for (const billingAccount of this.currentCompany.billingAccounts.map(res => res.id)) {
        this.getForm(billingAccount + 'FormControl').setValue(
          this.currentUser.billingAccounts.map(res => res.id).includes(billingAccount));
      }
    }
  }

  private redirectionToHomePage() {
    if (this.isClientCompany(this.getUserCurrent().company)) {
      location.assign('/#/client/' + this.getUserCurrent().company.uniqid);
    } else {
      location.assign('/#/mckay/' + this.getUserCurrent().company.uniqid);
    }
  }

  get registerFormControls() {
    return this.registerForm.controls;
  }

  private getForm(formName: string): AbstractControl {
    return this.registerForm.get(formName);
  }

  get nameForm(): AbstractControl {
    return this.getForm('name');
  }

  get isNotificationOnlyForm(): AbstractControl {
    return this.getForm('isNotificationOnly');
  }

  get emailForm(): AbstractControl {
    return this.getForm('email');
  }

  get roleSuperForm(): AbstractControl {
    return this.getForm('roleSuper');
  }

  get roleAdministratorForm(): AbstractControl {
    return this.getForm('roleAdministrator');
  }

  get roleDeveloperForm(): AbstractControl {
    return this.getForm('roleDeveloper');
  }

  get roleOperationsForm(): AbstractControl {
    return this.getForm('roleOperations');
  }

  get roleFinanceForm(): AbstractControl {
    return this.getForm('roleFinance');
  }

  get roleDadForm(): AbstractControl {
    return this.getForm('roleDadReporter');
  }

  get roleMacForm(): AbstractControl {
    return this.getForm('roleMacPermissioner');
  }

  get daytimePhoneCountryCodeForm(): AbstractControl {
    return this.getForm('daytimePhoneCountryCode');
  }

  get daytimePhoneNationalNumberForm(): AbstractControl {
    return this.getForm('daytimePhoneNationalNumber');
  }

  get mobilePhoneCountryCodeForm(): AbstractControl {
    return this.getForm('mobilePhoneCountryCode');
  }

  get mobilePhoneNationalNumberForm(): AbstractControl {
    return this.getForm('mobilePhoneNationalNumber');
  }

  get apiKeyForm(): AbstractControl {
    return this.getForm('apiKey');
  }

  get passwordForm(): AbstractControl {
    return this.getForm('password');
  }

  get confirmPasswordForm(): AbstractControl {
    return this.getForm('confirmPassword');
  }

  get commercialOptInForm(): AbstractControl {
    return this.getForm('commercialOptIn');
  }

  get receiveConfirmationEmailsForm(): AbstractControl {
    return this.getForm('receiveConfirmationEmails');
  }

  private getFormUnlock(formName: string): AbstractControl {
    return this.unlockForm.get(formName);
  }

  get unlockPasswordForm(): AbstractControl {
    return this.getFormUnlock('password');
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  onSubmit() {
    if (this.page === PageCrud.SHOW) {
      return;
    }
    this.submitted = true;
    this.passwordIsInvalid = false;
    if (this.page === PageCrud.EDIT && !this.passwordIsValid && this.passwordForm && this.passwordForm.value !== '') {
      this.passwordIsInvalid = true;
      return;
    }
    if (this.isFormInvalid() || this.hasRolesErrors() || !this.isValidDaytimePhone() || !this.isValidMobilePhone() || !this.validPassword()) {
      return;
    }
    this.submitted = false;
    const acknowledgeDomains = this.currentCompany.acknowledgeDomains;
    const emailSuffix = this.customUserService.getEmailDomain(this.emailForm.value);
    const userHasDifferentDomain = this.userUtilsService.userHasDifferentDomain(acknowledgeDomains, emailSuffix);
    if (this.page === PageCrud.EDIT) {
      this.updateUser(userHasDifferentDomain, emailSuffix);
    } else {
      this.addUser(userHasDifferentDomain, emailSuffix);
    }
  }

  /**  checking all the  form validity */
  private isFormInvalid(): boolean {
    return this.registerForm.invalid || !this.hasBillingAccount() || !this.hasRoles();
  }

  /**  checking if there are role errors */
  private hasRolesErrors(): boolean {
    return this.uniqRolesErrorsArray.length > 0;
  }

  updateUser(userHasDifferentDomain: boolean, emailSuffix: string): void {
    const userData = this.getUserDataFromForm();
    this.updateInfoUser = this.setUserInfo(userData);
    this.updateInfoUser['id'] = this.currentUser.id;
    this.handleCommonUserProperties();
    if (this.isClientCompany(this.currentCompany)) {
      userData['billingAccounts'] = this.getBillingAccounts();
    }
    this.handleUserUpdate(userHasDifferentDomain, emailSuffix);
  }

  addUser(userHasDifferentDomain: boolean, emailSuffix: string, checkMckayEntities = true): void {
    const currentUserRoles = this.getGroup();
    if (checkMckayEntities && currentUserRoles.includes(5) && this.companyUniqId !== 'admin') {
      this.getMckayEntities();
    } else {
      const userData = this.getUserDataFromForm();
      this.newUserData = this.setUserInfo(userData);
      this.handleUserAdd(userHasDifferentDomain, emailSuffix);
    }
  }

  private handleCommonUserProperties(): void {
    if (this.apiKeyForm.value !== this.currentUser.apiKey) {
      this.updateInfoUser['apiKey'] = this.apiKeyForm.value;
    }
    if (this.passwordForm.value !== '') {
      this.updateInfoUser['password'] = this.passwordForm.value;
    }
    if (this.commercialOptInForm.value !== this.currentUser.commercialOptIn) {
      this.updateInfoUser['commercialOptIn'] = this.commercialOptInForm.value;
    }
  }

  private handleUserUpdate(userHasDifferentDomain: boolean, emailSuffix: string): void {
    if (!userHasDifferentDomain || this.updateInfoUser['email'] === this.currentUser.emailShown) {
      this.sendUpdateUserRequest();
      return;
    }
    this.checkAndConfirmNewDomain(emailSuffix, 'update');
  }

  private handleUserAdd(userHasDifferentDomain: boolean, emailSuffix: string): void {
    if (!userHasDifferentDomain) {
      this.sendAddUserRequest();
      return;
    }

    this.checkAndConfirmNewDomain(emailSuffix, 'add');
  }

  private checkAndConfirmNewDomain(emailSuffix: string, action: string): void {
    if (this.isClientCompany(this.authenticationService.userCurrent.company)) {
      if (this.userUtilsService.isNdaMissingOrExpired(this.authenticationService.userCurrent.company)) {
        this.expiredNdaError = true;
        return;
      }
      this.manageAcknowledgedDomainPopUp();
      return;
    }
    if (action === 'add') {
      if (!this.isClientCompany(this.currentCompany) || confirm(emailSuffix + ' is not in the acknowledged domains of ' + this.currentCompany.name + '. Do you still want to proceed?')) {
        this.sendAddUserRequest();
        this.isGenericDomain();
      }
    } else {
      if (confirm(emailSuffix + ' is not in the acknowledged domains of ' + this.currentCompany.name + '. Do you still want to proceed?')) {
        this.sendUpdateUserRequest();
        this.currentCompany.acknowledgeDomains = this.userUtilsService.appendAcknowledgedDomain(
          this.currentCompany.acknowledgeDomains, emailSuffix
        );
      }
    }
  }

  private getUserDataFromForm(): any {
    const userData = {};
    userData['username'] = this.emailForm.value;
    userData['email'] = this.emailForm.value;
    return userData;
  }

  private sendAddUserRequest() {
    this.isFinanceUserSelected = false;
    this.userService.postUserCollection(this.newUserData).subscribe({
        next: user => {
          this.userHasDifferentDomainName = user.hasDifferentDomain;
          if (user.emailShown) {
            this.userDomainIfHeHasDifferentDomainName = user.emailShown.substring(user.emailShown.lastIndexOf('@') + 1);
          }
          this.isReceiveConfirmationEmails = this.newUserData['receiveConfirmationEmails'];
          this.isGenericDomain();
          this.successAddUser();
        },
        error: error => {
          this.errorAddUser(error);
        }
      }
    );
  }

  private errorAddUser(error) {
    if (error.status === 409) {
      this.error = false;
      this.existingEmail = true;
      this.existingUserLink = error.error?.userUniqid
        ? '#/' + this.getUserCurrent().company.uniqid + '/' + error.error.companyUniqid + '/' + error.error.userUniqid + '/show'
        : null;
      this.success = false;
    } else {
      this.error = true;
      this.errorMessage = 'An error occurred while processing your request';
      this.existingEmail = false;
      this.success = false;
    }
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }

  private successAddUser() {
    this.authenticationService.numberOfTotalUsers++;
    if (!this.isClientCompany(this.currentCompany)) {
      this.authenticationService.numberOfActiveUsers++;
    }
    this.error = false;
    this.existingEmail = false;
    this.expiredNdaError = false;
    this.success = true;
    this.submitted = false;
    this.registerForm.reset();
    this.alterIsNotificationOnly();
    // After adding a user, the billing accounts checkboxes are all checked by default
    for (const billingAccount of this.currentCompany.billingAccounts) {
      this.getForm(billingAccount.id + 'FormControl').setValue(true);
    }
    this.receiveConfirmationEmailsForm.setValue(true);
    this.commercialOptInForm.setValue(true);
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }

  private sendUpdateUserRequest() {
    this.userService.putUserItem(this.updateInfoUser['id'], this.updateInfoUser).subscribe({
        next: () => {
          if (this.emailForm.value === this.currentUser.emailShown) {
            this.error = false;
            this.existingEmail = false;
            this.successEditEmail = false;
            this.expiredNdaError = false;
            this.success = true;
          } else {
            if (this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.getUserCurrent(),
              ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN'])) {
              this.successEditEmail = false;
              this.success = true;
            } else {
              this.error = false;
              this.existingEmail = false;
              this.successEditEmail = true;
              this.expiredNdaError = false;
              this.success = false;
              this.currentUser.emailShown = this.updateInfoUser['email'];
            }
          }
          this.currentUser.name = this.updateInfoUser['name'];
          this.currentUser.daytimePhone = this.updateInfoUser['daytimePhone'];
          this.currentUser.mobilePhone = this.updateInfoUser['mobilePhone'];
          this.currentUserRoles = this.updateInfoUser['roleGroups'];
          if (this.currentUser.id === this.getUserCurrent().id) {
            this.getUserCurrent().commercialOptIn = this.updateInfoUser['commercialOptIn'];
          }
          this.passwordForm?.setValue('');
          this.confirmPasswordForm?.setValue('');
          window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          this.isGenericDomain();
          this.refreshAuditHistory();
        },
        error: error => {
          this.success = false;
          if (error.status === 404) {
            this.userNotFound = true;
          } else if (error.status === 406) {
            this.error = true;
            this.errorMessage = 'Cannot remove the role ' + error.error.role + ' from this user because they are the last active user with that role.';
          } else if (error.status === 401) {
            this.error = true;
            this.errorMessage = 'An error occurred while processing your request';
            this.existingEmail = false;
            this.successEditEmail = false;
            this.success = false;
          }
          window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        }
      }
    );
  }

  private setUserInfo(userData: any) {
    userData['company'] = 'api/companies/' + this.currentCompany.id;
    userData['name'] = this.nameForm.value;
    userData['isNotificationOnly'] = this.isNotificationOnlyForm.value;
    userData['daytimePhone'] = this.userUtilsService.parsePhoneNumber(this.daytimePhoneCountryCodeForm.value,
      this.daytimePhoneNationalNumberForm.value);
    userData['mobilePhone'] = this.userUtilsService.parsePhoneNumber(this.mobilePhoneCountryCodeForm.value,
      this.mobilePhoneNationalNumberForm.value);
    userData['roleGroups'] = this.getGroup();
    userData['commercialOptIn'] = this.commercialOptInForm.value;
    userData['receiveConfirmationEmails'] = this.receiveConfirmationEmailsForm.value;
    if (this.isClientCompany(this.currentCompany)) {
      userData['billingAccounts'] = this.getBillingAccounts();
    }
    userData['dadConfigs'] = this.getDadConfigs();
    if (userData['roleGroups'].includes(5) && this.companyUniqId !== 'admin') {
      userData['invoicePermission'] = {mckay_entities: this.mckayEntities ? this.mckayEntities.filter(entity => entity.checked).map(entity => entity.shortname) : ''};
    }
    return userData;
  }

  getBillingAccounts() {
    const billingAccounts = [];
    for (const billingAccount of this.billingAccounts) {
      if (this.getForm(billingAccount.formControlName).value) {
        billingAccounts.push(billingAccount.id);
      }
    }
    billingAccounts.sort();
    return billingAccounts;
  }

  hasRoles(): boolean {
    return !!this.roleCheckBoxes.map(roleCheckBox => this.getForm(roleCheckBox.formControlName))
      .find(roleFormControls => !!roleFormControls.value);
  }

  isValidDaytimePhone(): boolean {
    return this.userUtilsService.isValidPhone(this.daytimePhoneCountryCodeForm.value, this.daytimePhoneNationalNumberForm.value);
  }

  isValidDaytimePhoneCountryCode(): boolean {
    return this.userUtilsService.isValidPhoneCountryCode(this.daytimePhoneCountryCodeForm.value, this.daytimePhoneNationalNumberForm.value);
  }

  isValidDaytimePhoneNationalNumber(): boolean {
    return this.userUtilsService.isValidPhoneNationalNumber(this.daytimePhoneCountryCodeForm.value, this.daytimePhoneNationalNumberForm.value);
  }

  isValidMobilePhone(): boolean {
    return this.userUtilsService.isValidPhone(this.mobilePhoneCountryCodeForm.value, this.mobilePhoneNationalNumberForm.value);
  }

  isValidMobilePhoneCountryCode(): boolean {
    return this.userUtilsService.isValidPhoneCountryCode(this.mobilePhoneCountryCodeForm.value, this.mobilePhoneNationalNumberForm.value);
  }

  isValidMobilePhoneNationalNumber(): boolean {
    return this.userUtilsService.isValidPhoneNationalNumber(this.mobilePhoneCountryCodeForm.value, this.mobilePhoneNationalNumberForm.value);
  }

  getGroup() {
    const groupsIds: number[] = this.roleCheckBoxes.filter(roleCheckBox => !!this.getForm(roleCheckBox.formControlName).value).map(roleCheckBox => roleCheckBox.groupId).sort();
    return this.roleService.parseToArray(groupsIds);
  }

  private loadDataToEditAndShowPages() {
    this.nameForm.setValue(this.currentUser.name);
    this.isNotificationOnlyForm.setValue(this.currentUser.isNotificationOnly);
    this.emailForm.setValue(this.currentUser.emailShown);
    this.roleAdministratorForm.setValue(
      this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser, ['ROLE_MCKAY_ADMIN', 'ROLE_CLIENT_ADMIN']));
    this.roleDeveloperForm.setValue(
      this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser, ['ROLE_MCKAY_DEVELOPER', 'ROLE_CLIENT_DEVELOPER']));
    this.roleOperationsForm.setValue(
      this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser, ['ROLE_MCKAY_OPERATIONS', 'ROLE_CLIENT_OPERATIONS']));
    this.roleFinanceForm.setValue(
      this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser, ['ROLE_MCKAY_FINANCE', 'ROLE_CLIENT_FINANCE']));
    this.roleDadForm.setValue(this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser,
      ['ROLE_MCKAY_DAD_REPORTER', 'ROLE_CLIENT_DAD_REPORTER']));
    this.roleMacForm.setValue(this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser,
      ['ROLE_MCKAY_MAC_PERMISSIONER', 'ROLE_CLIENT_MAC_PERMISSIONER']));
    this.daytimePhoneCountryCodeForm.setValue(this.getDaytimePhoneCountryCode());
    this.daytimePhoneNationalNumberForm.setValue(this.getDaytimePhoneNationalNumber());
    this.mobilePhoneCountryCodeForm.setValue(this.getMobilePhoneCountryCode());
    this.mobilePhoneNationalNumberForm.setValue(this.getMobilePhoneNationalNumber());
    this.commercialOptInForm.setValue(this.currentUser.commercialOptIn);
    if (this.isClientCompany(this.currentCompany) && this.currentCompany.billingAccounts) {
      for (const billingAccount of this.currentCompany.billingAccounts.map(res => res.id)) {
        this.getForm(billingAccount + 'FormControl').setValue(
          this.currentUser.billingAccounts && this.currentUser.billingAccounts.map(res => res.id).includes(billingAccount));
      }
    }
  }

  getDaytimePhoneCountryCode(): string {
    return this.userUtilsService.extractCountryCode(this.currentUser.daytimePhone);
  }

  getMobilePhoneCountryCode(): string {
    return this.userUtilsService.extractCountryCode(this.currentUser.mobilePhone);
  }

  getDaytimePhoneNationalNumber(): string {
    return this.userUtilsService.extractNationalNumber(this.currentUser.daytimePhone);
  }

  getMobilePhoneNationalNumber(): string {
    return this.userUtilsService.extractNationalNumber(this.currentUser.mobilePhone);
  }

  showUnlockDialog() {
    this.invalidPasswordOnEditMode = false;
    this.unlockDialogDisplay = true;
    this.unlockPasswordForm.reset();
  }

  regenerateApi(user: User, event: Event): void {
    this.confirmationService.confirm({
      key: 'regenerateApiKey',
      target: event.target as EventTarget,
      acceptIcon: 'pi pi-check mr-1',
      rejectIcon: 'pi pi-times mr-1',
      acceptLabel: 'Regenerate',
      rejectLabel: 'Cancel',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm',
      acceptButtonStyleClass: 'p-button-sm p-button-danger',
      accept: () => {
        this.customUserService.resetApiKey(user.uniqid).subscribe({
            next: (res: string) => {
              this.apiKeyForm.setValue(res);
              this.currentUser.apiKey = res;
              this.successMessage = 'User\'s API key has been reset.';
              window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
            },
            error: () => {
              this.error = true;
              this.existingEmail = false;
              this.successEditEmail = false;
              this.success = false;
            }
          }
        );
      }
    });
  }

  checkDad(dadId: number): boolean {
    if (this.isAddPage()) {
      return true;
    }
    if (!this.currentUser || !this.currentUser.dadConfigs) {
      return false;
    }
    return this.currentUser.dadConfigs.map(dadConfig => dadConfig.id).includes(dadId);
  }

  userHasOneOfThoseRoles(roles: string[], user: User) {
    return this.userLoggedRolesServiceService.userHasOneOfThoseRoles(user, roles);
  }

  hasGroup(role: string, user: User) {
    return user.roleGroups.map(group => group.name).includes(role);
  }

  validPassword() {
    if (this.page === PageCrud.ADD) {
      return true;
    }
    return this.confirmPasswordForm.value === this.passwordForm.value;
  }

  hideUnlockDialog() {
    this.unlockDialogDisplay = false;
  }

  onSubmitUnlock() {
    if (this.unlockForm.invalid) {
      return;
    }
    this.passwordUnlockForm['password'] = this.unlockPasswordForm.value;
    this.customUserService.verifyUserPassword(this.passwordUnlockForm).subscribe({
        next: () => {
          this.isEditModeConfirmed = !this.isEditModeConfirmed;
          this.registerForm.enable();
          this.roleSuperForm.disable();
          this.enabledTransferSuperRoleButton = true;
          this.alterIsNotificationOnly();
          this.isNotificationOnlyForm.disable();
          this.hideUnlockDialog();
          this.invalidPasswordOnEditMode = false;
        },
        error: () => {
          this.unlockForm.reset();
          this.invalidPasswordOnEditMode = true;
        }
      }
    );
  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }

  passwordChangeIsValid(): boolean {
    if (!this.passwordForm?.value && !this.confirmPasswordForm?.value) {
      return true;
    }
    return this.passwordIsValid;
  }

  canChangeSuperRole() {
    return this.userUtilsService.canChangeSuperRole(this.getUserCurrent(), this.currentUser, this.isUserToEditInSameCompanyAsLoggedInUser, this.page);
  }

  changeSuperRole() {
    if (confirm(`There can be only one superuser per client company.
     Please confirm that you want to transfer superuser role to this user.`)) {
      this.httpClient.put<any>(environment.baseUrlWs + '/api/transfer-super-role/'
        + this.currentUser.id, {'transferSuperRole': true}).subscribe({
          next: () => {
            this.successTransferSuperRole = true;
            this.refreshAuditHistory();
            this.roleSuperForm.setValue(true);
            this.registerForm.disable();
            this.enabledTransferSuperRoleButton = false;
            this.nameForm.disable();
            this.emailForm.disable();
            this.daytimePhoneCountryCodeForm.disable();
            this.daytimePhoneNationalNumberForm.disable();
            this.mobilePhoneCountryCodeForm.disable();
            this.mobilePhoneNationalNumberForm.disable();
            for (const billingAccount of this.currentCompany.billingAccounts) {
              this.getForm(billingAccount.id + 'FormControl').disable();
            }
            this.isEditModeConfirmed = false;
          }, error: () => {
            this.error = true;
          }
        }
      );
    }
  }

  isAddPage() {
    return this.page === PageCrud.ADD;
  }

  isEditPage() {
    return this.page === PageCrud.EDIT;
  }

  isShowPage() {
    return this.page === PageCrud.SHOW;
  }

  isClientCompany(company: Company) {
    return !!company && company.uniqid !== 'admin';
  }

  hasBillingAccount() {
    return !this.isClientCompany(this.currentCompany)
      || !this.hasCompanyBillingAccount(this.currentCompany)
      || !!this.getBillingAccountFormControls().find(billingAccountFormControl => billingAccountFormControl.value);
  }

  getBillingAccountFormControls(): AbstractControl[] {
    return this.billingAccounts.map(billingAccountCheckbox => this.getForm(billingAccountCheckbox.formControlName));
  }

  hasCompanyBillingAccount(currentCompany: Company) {
    return currentCompany.billingAccounts && currentCompany.billingAccounts.length > 0;
  }

  getDadConfigs() {
    const activeIds = this.dadReportingsCheckbox.map(dadConfig => dadConfig.id);
    const checkedIds = this.dadReportingsCheckbox
      .filter(dadConfig => this.getForm(dadConfig.name).value === true)
      .map(dadConfig => dadConfig.id);
    const inactiveIds = (this.currentUser?.dadConfigs ?? [])
      .map(dadConfig => dadConfig.id)
      .filter(id => !activeIds.includes(id));
    return [...checkedIds, ...inactiveIds]
      .sort((first, second) => first - second)
      .map(id => 'api/dad-config/' + id);
  }

  private manageAcknowledgedDomainPopUp() {
    const ref = this.openAcknowledgedDomainPopUp();
    this.closeAcknowledgedDomainPopUp(ref);
  }

  private openAcknowledgedDomainPopUp() {
    return this.dialogService.open(AcknowledgedDomainConfirmationComponent, {
      width: '90%',
      showHeader: false,
      style: {'max-height': '100%', 'overflow-y': 'scroll'},
      dismissableMask: true,
      data: {
        loggedInUser: this.authenticationService.userCurrent,
        newUser: this.isAddPage() ? this.newUserData : this.updateInfoUser
      },
    });
  }

  closeAcknowledgedDomainPopUp(ref: DynamicDialogRef) {
    ref.onClose.subscribe(res => {
      if (!res) {
        return;
      }
      if (this.isEditPage()) {
        this.updateInfoUser['acknowledgedDomainInfo'] = res;
        this.sendUpdateUserRequest();
      } else {
        this.newUserData['acknowledgedDomainInfo'] = res;
        this.sendAddUserRequest();
      }
    });
  }

  private isGenericDomain() {
    if (!this.emailForm.value) {
      return;
    }
    let domain = this.emailForm.value.substring(this.emailForm.value.indexOf('@') + 1);
    if ((domain.split('.')).length > 2) {
      const emailDomains = domain.split('.');
      const emailDomainsLength = emailDomains.length;
      domain = emailDomains[emailDomainsLength - 2] + '.' + emailDomains[emailDomainsLength - 1];
    }
    this.customUserService.isGenericDomain(domain).subscribe(
      isGeneric => {
        if (!isGeneric) {
          this.currentCompany.acknowledgeDomains = this.userUtilsService.appendAcknowledgedDomain(
            this.currentCompany.acknowledgeDomains, domain
          );
        }
      }
    );
  }

  get hasMultipleBusinessUnits() {
    if (!this.currentCompany.billingAccounts) {
      return false;
    }
    return this.currentCompany.billingAccounts.length > 1;
  }

  lastUserWithThisRole(event, role) {
    // There must always be at least one user for each role in the company
    if (!this.uniqRolesArray.includes(role.groupId)) {
      return;
    }
    if (event.currentTarget.checked) {
      this.uniqRolesErrorsArray = this.uniqRolesErrorsArray.filter(str => str !== role.label);
      this.uniqRolesError = this.uniqRolesErrorsArray.length > 0;
      return;
    }
    this.uniqRolesErrorsArray.push(role.label);
    this.uniqRolesError = true;
  }

  get uniqRolesErrorsArrayString() {
    return this.uniqRolesErrorsArray.join(', ');
  }

  private refreshAuditHistory() {
    this.auditHistory?.reload();
  }

  canEditUser(user: any) {
    return this.userUtilsService.canEditUser(this.authenticationService.userCurrent, user);
  }

  getMckayEntities(): void {
    this.manageInvoiceRecipientsService.getMckayEntities(this.companyUniqId)
      .subscribe({
          next: data => {
            this.mckayEntities = Object.keys(data).map(key => {
              const name = data[key].name + ' (' + data[key].territory + ')';
              return {label: name, value: key, checked: true, shortname: data[key].shortname};
            });
            if (this.page === PageCrud.ADD) {
              this.isFinanceUserSelected = true;
            }
          },
          error: error => {
            this.handleError(error);
          }
        }
      );
  }

  saveMckayEntities() {
    const acknowledgeDomains = this.currentCompany.acknowledgeDomains;
    const emailSuffix = this.customUserService.getEmailDomain(this.emailForm.value);
    const userHasDifferentDomain = this.userUtilsService.userHasDifferentDomain(acknowledgeDomains, emailSuffix);
    this.addUser(userHasDifferentDomain, emailSuffix, false);
  }

  replaceEntitiesNames(): string[] {
    const listOfMckayEntities = this.currentUser.invoicePermission ? this.currentUser.invoicePermission.mckay_entities : [];
    if (Array.isArray(listOfMckayEntities) && this.mckayEntities && this.mckayEntities.length > 0) {
      return listOfMckayEntities.map(item => {
        this.mckayEntities.forEach(entity => {
          item = item.replace(entity.shortname, entity.label);
        });
        return item;
      });
    } else {
      return listOfMckayEntities;
    }
  }

  isClientUser() {
    return this.isClientCompany(this.currentCompany);
  }

  alterDisplayHelpPopUp() {
    this.displayHelpPopUp = !this.displayHelpPopUp;
  }

  alterIsNotificationOnly() {
    const isDisabledSuperForm = this.roleSuperForm.disabled;
    if (this.isNotificationOnlyForm.value) {
      this.superLockedByDistributionList = this.superLockedByDistributionList || !isDisabledSuperForm;
      this.roleAdministratorForm.setValue(false);
      this.roleAdministratorForm.disable();
      this.roleSuperForm.setValue(false);
      this.roleSuperForm.disable();
      this.roleDeveloperForm.setValue(false);
      this.roleDeveloperForm.disable();
      this.roleMacForm.setValue(false);
      this.roleMacForm.disable();
      this.roleDadForm.setValue(false);
      this.roleDadForm.disable();
      return;
    }
    // Enable editing for the roles
    if (!isDisabledSuperForm || this.superLockedByDistributionList) {
      this.roleSuperForm.enable();
    }
    this.superLockedByDistributionList = false;
    if (!this.roleOperationsForm.disabled) {
      this.roleAdministratorForm.enable();
      this.roleDeveloperForm.enable();
      this.roleMacForm.enable();
      this.roleDadForm.enable();
    }
  }

  protected canConvertToDistributionList() {
    return this.userUtilsService.shouldShowDistributionListButtons(this.page, this.currentUser, this.getUserCurrent());
  }

  convertToDistributionList(event: Event) {
    this.confirmationService.confirm({
      key: 'distributionListActivate',
      target: event.target as EventTarget,
      acceptIcon: 'pi pi-check mr-1',
      rejectIcon: 'pi pi-times mr-1',
      acceptLabel: 'Convert',
      rejectLabel: 'Cancel',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm',
      acceptButtonStyleClass: 'p-button-sm p-button-danger',
      accept: () => {
        this.customUserService.activateDistributionList(this.currentUser.uniqid).subscribe(res => {
          this.currentUser = res;
          this.loadDataToEditAndShowPages();
          this.success = true;
          this.refreshAuditHistory();
        });
      }
    });
  }

  convertToStandardUser(event: Event) {
    this.confirmationService.confirm({
      key: 'distributionListDeactivate',
      target: event.target as EventTarget,
      acceptIcon: 'pi pi-check mr-1',
      rejectIcon: 'pi pi-times mr-1',
      acceptLabel: 'Convert',
      rejectLabel: 'Cancel',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm',
      acceptButtonStyleClass: 'p-button-sm p-button-danger',
      accept: () => {
        this.customUserService.deactivateDistributionList(this.currentUser.uniqid).subscribe(res => {
          this.currentUser = res;
          this.success = true;
          this.refreshAuditHistory();
        });
      }
    });
  }
}
